var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book-tags",staticStyle:{"display":"ruby"}},_vm._l((_vm.tags),function(tag){return _c('div',{key:tag,staticClass:"tag",staticStyle:{"margin":"2px","font-size":"13px"}},[_vm._v(" "+_vm._s(tag)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }